<template>
    <v-row class="d-flex" v-if="!resourceLoading && resource" style="max-width: 1500px">
        <v-col cols="12" xl="10" lg="10" md="10" sm="12">
            <div class="float-right">
                <ShareButton :title="resource.name"/>
            </div>
            <h1 class="mt-0 mb-auto pb-0 vs-header">
                {{ resource.name }}
            </h1>
            <!--
            <h2 class="mb-4 mt-1">
                <template
                    v-if="resource.format">
                    <v-icon>{{ resource.format.icon }}</v-icon>
                    <template v-if="!resource.package_type">{{ resource.format.full_name }}</template>
                </template>
                <template v-if="resource.package_type">{{resource.package_type.name}}</template>
            </h2>
            -->

            <h2 class="mt-1 d-flex align-items-center">
                <template
                    v-if="resource.format">
                    <v-icon>{{ resource.format.icon }}</v-icon>
                </template>
                <template v-if="resource.labels.length > 0">{{resource.labels[0].name}}</template>
                <template v-if="resource.format"> {{ resource.format.name }}</template>
                <v-img
                    v-if="resource.country?.picture_filename"
                    :lazy-src="require('../assets/flags/'+resource.country.picture_filename)"
                    :src="require('../assets/flags/'+resource.country.picture_filename)"
                    :title="resource.country.name"
                    :alt="resource.country.name"
                    class="small-flag ml-2 mt-1 mt-md-2" style="display: flex"
                />
            </h2>
            <h2 v-if="resource.label_groups.length > 0 || resource.label_id">
                <span v-if="resource.label_groups.length > 0">{{resource.label_groups[0].name}}</span>
                <span v-if="resource.label_id" class="ml-1">id: {{ resource.label_id }}</span>
            </h2>

            <!-- header box -->
            <v-row
                dense
                class="header-box mt-4"
            >
                <v-col
                    cols="12"
                    xl="3"
                    lg="4"
                    md="4"
                    sm="4"
                    class="text-center"
                >
                    <!-- release picture
                    <listing-picture
                        :picture="resource.picture"
                        :alt="$t('open')"
                        :size="$vuetify.breakpoint.name == 'xs' ? 'sm' : 'md'"
                        direction="front"
                        :class="{'cursor-pointer': resource.picture}"
                        :link="resource.picture ? 'dialog' : false"
                        @openDialog="!dialog ? dialog = true : dialog = false"
                        :user_flag="userFlag"
                    ></listing-picture>
                    -->
                    <v-img
                        :alt="$t('open')"
                        :title="resource.name"
                        class="vs-profile-picture"
                        :class="{
                            'cursor-pointer': resource.picture,
                            'my_entries': resource.list_entries_count_auth,
                            'my_wanted': resource.wanted_count_auth,
                            'my_owned': resource.owned_count_auth,
                            }"
                        :lazy-src="imgSrc(resource.picture, 'xs', 'front')"
                        :src="imgSrc(resource.picture, 'sm', 'front')"
                        @click="resource.picture ? dialog = true : false"
                        contain
                        width="100%"
                    />
                </v-col>
                <v-col
                    cols="8"
                    xl="9"
                    lg="8"
                    md="8"
                    sm="8"
                    class="hidden-xs-only"
                >
                    <!-- basic info -->
                    <details-table
                        :resources="basicInfo"
                    />

                    <!-- rating
                    <v-chip class="mr-1 mt-3"  small :x-small="this.$vuetify.breakpoint.name == 'xs'" :title="$t('rating')">
                        <v-rating
                            length="5"
                            :half-increments="true"
                            color="yellow"
                            background-color="grey"
                            readonly
                            dense
                            :x-small="this.$vuetify.breakpoint.name == 'xs'"
                            :value="resource.user_reviews_rating"
                            :title="$t('rating')+': '+resource.user_reviews_rating+' '"
                        ></v-rating>
                        <b class="smaller-txt" v-if="resource.user_reviews_count > 0">{{ resource.user_reviews_count }}</b>
                        <b class="smaller-txt" v-else>0</b>
                    </v-chip>
                    -->
                    <!-- like indicator -->
                    <v-chip class="mr-1 mt-3"
                            :title="$t('likes')"
                            :color="resource.likes_count_auth ? 'green':null"
                    >
                        <v-icon x-small class="mr-1" >mdi-heart</v-icon>
                        <b class="smaller-txt">{{ resource.likes_count }} {{ $t('likes') }}</b>
                    </v-chip>
                    <!-- have indicator -->
                    <v-chip class="mr-1 mt-3"
                            v-if="resource.owned_count_auth"
                            :title="$t('you have this')"
                            color="green"
                    >
                        <v-icon x-small class="mr-1" >mdi-flag-outline</v-icon>
                        <b class="smaller-txt">{{ $t('you have this') }}</b>
                    </v-chip>
                    <!-- have indicator -->
                    <v-chip class="mr-1 mt-3"
                            v-if="resource.wanted_count_auth"
                            :title="$t('you want this')"
                            color="orange"
                    >
                        <v-icon x-small class="mr-1" >mdi-flag-plus</v-icon>
                        <b class="smaller-txt">{{ $t('you want this') }}</b>
                    </v-chip>
                    <!-- posts
                    <v-chip class="mr-1 mt-3" small :title="$t('comments')">
                        <v-icon x-small class="mr-1">mdi-comment</v-icon>
                        <b class="smaller-txt">{{ resource.posts_count }}</b>
                    </v-chip>
                    -->
                    <!-- subPageButtons for xsmall screens
                    <sub-page-buttons
                        class="mt-1"
                        :buttons="subPageButtons"
                        @openDialog="$store.state.auth_user ? dialog_delete = true : $root.$emit('login-prompt')"
                        :route="subPage"
                        :base_url="'/'+baseUrl+'/'+publicId"
                    >
                    </sub-page-buttons>
                     -->
                </v-col>
                <v-col
                    cols="12"
                >
                    <!-- subPageButtons for large screens -->
                    <sub-page-buttons
                        :buttons="subPageButtons"
                        @openDialog="$store.state.auth_user ? dialog_delete = true : $root.$emit('login-prompt')"
                        :route="subPage"
                        :base_url="'/'+baseUrl+'/'+publicId"
                    >
                    </sub-page-buttons>
                </v-col>
            </v-row>

            <!-- subpages under keep alive -->
            <keep-alive>

                <!-- main page -->
                <v-row
                    v-if="!subPage"
                >
                    <v-col
                        cols="12"
                        class="pt-0"
                    >

                        <!-- value -->
                        <template v-if="resource.price_avg && resource.price_avg > 0">
                            <h3 class="headline sentence-caps mb-3">{{ $t('value') }} <span class="ml-2"><v-icon color="green" style="font-size: 1.2em" @click="dialog_value=true">mdi-help-circle-outline</v-icon></span></h3>
                            <div>
                                <span @click="dialog_value=true"><v-icon >mdi-cash-check</v-icon> <b>{{ valueAvg }} €</b></span>
                                <span class="ml-5" @click="dialog_value=true"><v-icon>mdi-account-voice</v-icon> <b>{{ resource.price_avg_votes }}</b></span>
                                <span class="ml-6" @click="dialog_value=true" v-if="resource.price_avg_votes > 1"><v-icon color="red">mdi-arrow-up-bold</v-icon> <b>{{ valueMax }} €</b></span>
                                <span class="ml-3" @click="dialog_value=true" v-if="resource.price_avg_votes > 1"><v-icon color="green">mdi-arrow-down-bold</v-icon> <b>{{ valueMin }} €</b></span>
                                <span class="ml-6 hidden-xs-only">
                                    <router-link :to="'/release/'+this.resource.public_id+'/user_collections'">
                                        {{ $t('user collections') }}<v-icon>mdi-arrow-right</v-icon>
                                    </router-link>
                                </span>
                                <div v-if="resource.RRP && resource.rrp_currency" class="mt-1">
                                    ({{ $t('rrp') }}: {{resource.RRP }} {{resource.rrp_currency.label }})
                                </div>
                            </div>

                            <div class="hidden-sm-and-up mt-3">
                                <router-link :to="'/release/'+this.resource.public_id+'/user_collections'">
                                    {{ $t('user collections') }}<v-icon>mdi-arrow-right</v-icon>
                                </router-link>
                            </div>


                            <v-divider class="mt-5"></v-divider>
                        </template>

                        <!-- cover description -->
                        <template v-if="resource.backcover">
                            <h3 class="headline sentence-caps" v-html="$t('backcover story description')" id="backcover"/>
                            <!--<transition name="fade" mode="out-in">-->

                            <template v-if="wordCount(resource.backcover) > 53 && !showAllBackCover">
                                <div v-html="cutStringByWords(resource.backcover, 53)" class="nl-break"></div>
                                <div class="vs-link float-right" @click="showAllBackCover = true">{{ $t('show more') }}<v-icon x-small>mdi-arrow-down</v-icon></div>
                            </template>
                            <template v-else>
                                <div v-html="resource.backcover" class="nl-break"></div>
                                <div v-if="wordCount(resource.backcover) > 53" class="vs-link float-right" @click="showAllBackCover = false; $vuetify.goTo('#backcover', goToParams)">{{ $t('show less') }}<v-icon x-small>mdi-arrow-up</v-icon></div>
                            </template>
                            <!--</transition>-->
                            <v-divider class="mt-5"></v-divider>
                        </template>

                        <!-- extras content -->
                        <template v-if="resource.extras">
                            <h3 class="headline sentence-caps" id="extras">{{ $t('extras')}}</h3>
                            <template v-if="wordCount(resource.extras) > 20 && !showAllExtras">
                                <div v-html="cutStringByWords(resource.extras, 20)" class="vs-long-text nl-break"></div>
                                <div class="vs-link float-right" @click="showAllExtras = true">{{ $t('show more') }}<v-icon x-small>mdi-arrow-down</v-icon></div>
                            </template>
                            <template v-else>
                                <div v-html="resource.extras" class="vs-long-text nl-break"></div>
                                <div v-if="resource.extras2" v-html="resource.extras2" class="vs-long-text nl-break"></div>
                                <div v-if="wordCount(resource.extras) > 20" class="vs-link float-right" @click="showAllExtras = false; $vuetify.goTo('#extras', goToParams)">{{ $t('show less') }}<v-icon x-small>mdi-arrow-up</v-icon></div>
                            </template>
                            <v-divider class="mt-5"></v-divider>
                        </template>

                        <!-- packaging content -->
                        <template v-if="resource.packaging">
                            <h3 class="headline sentence-caps" id="packaging">{{ $t('packaging')}}</h3>
                            <template v-if="wordCount(resource.packaging) > 20 && !showAllPackaging">
                                <div v-html="cutStringByWords(resource.packaging, 20)" class="nl-break"></div>
                                <div class="vs-link float-right" @click="showAllPackaging = true">{{ $t('show more') }}<v-icon x-small>mdi-arrow-down</v-icon></div>
                            </template>
                            <template v-else>
                                <div v-html="resource.packaging" class="vs-long-text nl-break"></div>
                                <div v-if="wordCount(resource.packaging) > 20" class="vs-link float-right" @click="showAllPackaging = false; $vuetify.goTo('#packaging', goToParams)">{{ $t('show less') }}<v-icon x-small>mdi-arrow-up</v-icon></div>
                            </template>
                            <v-divider class="mt-5"></v-divider>
                        </template>

                        <!-- mastering content -->
                        <template v-if="resource.mastering_details">
                            <h3 class="headline sentence-caps" id="mastering">{{ $t('mastering')}}</h3>
                            <b v-if="mastering" v-html="mastering+' '"/>
                            <b v-if="HDRString" v-html="HDRString+' '"/>
                            <b v-if="processing" v-html="'('+processing+') '"/>
                            <b v-if="resource.upscaled">(UPSCALED)</b>

                            <template v-if="wordCount(resource.mastering_details) > 20 && !showAllMastering">
                                <b v-if="HDRString" v-html="HDRString"/>
                                <div v-html="cutStringByWords(resource.mastering_details, 20)" class="nl-break"></div>
                                <div class="vs-link float-right" @click="showAllMastering = true">{{ $t('show more') }}<v-icon x-small>mdi-arrow-down</v-icon></div>
                            </template>
                            <template v-else>
                                <div v-html="resource.mastering_details" class="vs-long-text nl-break"></div>
                                <div v-if="wordCount(resource.mastering_details) > 20" class="vs-link float-right" @click="showAllMastering = false; $vuetify.goTo('#mastering', goToParams)">{{ $t('show less') }}<v-icon x-small>mdi-arrow-up</v-icon></div>
                            </template>
                            <v-divider class="mt-5"></v-divider>
                        </template>

                        <!-- censorship content -->
                        <template v-if="resource.cut_details">
                            <h3 class="headline sentence-caps" v-if="resource.cut_uncut == 1" id="censorship">{{ $t('release is cut')}}
                                <template v-if="resource.cut_seconds">
                                    {{ secondsToMinutes(resource.cut_seconds)}} {{ $t('min sec') }}
                                </template>
                            </h3>
                            <h3 class="headline sentence-caps" v-if="resource.cut_uncut == 2" id="censorship">{{ $t('release is uncut')}}</h3>
                            <template v-if="wordCount(resource.cut_details) > 20 && !showAllCensorship">
                                <div v-html="cutStringByWords(resource.cut_details, 20)" class="vs-long-text nl-break" ></div>
                                <div class="vs-link float-right" @click="showAllCensorship = true">{{ $t('show more') }}<v-icon x-small>mdi-arrow-down</v-icon></div>
                            </template>
                            <template v-else>
                                <div v-html="resource.cut_details" class="vs-long-text nl-break"></div>
                                <div v-if="wordCount(resource.cut_details) > 20" class="vs-link float-right" @click="showAllCensorship = false;$vuetify.goTo('#censorship', goToParams)">{{ $t('show less') }}<v-icon x-small>mdi-arrow-up</v-icon></div>
                            </template>
                            <v-divider class="mt-5"></v-divider>
                        </template>

                    </v-col>

                    <!-- xs ads -->
                    <v-col v-if="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'" cols="12">
                        {{ $t('movie deals') }}
                        <ShoppingLinks
                            :resource-links="resource.shopping_links"
                            :fall-back-picture="resource.picture"
                            :general-links-fixed-height="80"
                            :keyword="resource.titles.length > 0 ? resource.titles[0].name+' '+resource.titles[0].year : resource.name"
                            :format-id="resource.format ? resource.format.id : null"
                            :country-id="resource.country ? resource.country.id : null"
                            :parent-model="resource.model"
                            :parent-id="resource.id"
                            :user-login="Boolean($store.state.auth_user)"
                            :mode="2"
                            class="mb-3"
                        />
                    </v-col>

                    <!-- details -->
                    <v-col>
                        <h3 class="headline sentence-caps">{{ $t('details')}}</h3>

                        <!-- complete info -->
                        <details-table :resources="completeInfo" class="mb-16" />

                    </v-col>
                </v-row>
                <!-- // main page -->

                <!-- movies of the release -->
                <list-browser
                    v-if="subPage === '/movies'"
                    :key="'movie'"
                    :id="catalogueID"
                    type="movies_release"
                    api-route="titles"
                    :api-params="{
                      parent_model: 'release',
                      parent_id: this.resource.public_id,
                      so: 'released_asc'
                    }"
                    search-placeholder="search for movies"
                    default_item_component="ItemPictureTextInfo"
                    :dialog_buttons="movieDialogs.buttons"
                    :dialogs="movieDialogs.visibility"
                    :dialog_sources="movieDialogs.sources"
                    :dialog_properties="movieDialogs.properties"
                    :hide_dialogs="{}"
                    :reaction_buttons="true"
                    disable-divider
                >
                </list-browser>
                <!-- // movies of the release -->

                <!-- other releases for the parent release -->
                <list-browser
                    class="mt-5"
                    v-if="subPage === '/other_releases'"
                    :key="'other_releases'"
                    :id="catalogueID"
                    type="other_releases_release"
                    api-route="other_releases"
                    :api-params="{
                      parent_model: 'release',
                      parent_id: this.resource.public_id,
                      so: 'format',
                    }"
                    search-placeholder="search other releases"
                    default_item_component="ItemPicture"
                    :dialog_buttons="releaseDialogs.buttons"
                    :dialogs="releaseDialogs.visibility"
                    :dialog_sources="releaseDialogs.sources"
                    :dialog_properties="releaseDialogs.properties"
                    :hide_dialogs="{}"
                    :reaction_buttons="true"
                    picture-listing-label="label"
                    :custom-zero-results-message="$t('no other releases')"
                    :master-link="{
                        'label': $t('add new release'),
                        'icon': 'mdi-plus-box-outline',
                        'to': '/releases/new'
                    }"
                >
                </list-browser>
                <!-- // other releases for the parent release -->

                <!-- reviews -->
                <list-browser
                    class="mt-1"
                    v-if="subPage === '/reviews'"
                    :key="'reviews'"
                    :id="catalogueID"
                    type="reviews"
                    api-route="reviews_parent"
                    :api-params="{
                      parent_model: 'release',
                      parent_id: this.resource.id,
                    }"
                    search-placeholder="search reviews"
                    default_item_component="ItemPictureTextInfo"
                    :dialog_buttons="[]"
                    :dialogs="{}"
                    :dialog_properties="[]"
                    :dialog_sources="{}"
                    :hide_dialogs="{}"
                    hide-control-buttons
                    hide-results-ui
                    hide-search
                    disable-view-button
                    :reaction_buttons="true"
                    :master-link="{
                        'label': $t('write a review'),
                        'icon': 'mdi-pencil-plus-outline',
                        'to': '/release/'+resource.public_id+'/reviews/new'
                    }"
                    :custom-zero-results-message="$t('no reviews yet')"
                >
                </list-browser>
                <!-- // reviews -->

                <!-- user collections of the release -->
                <list-browser
                    v-if="subPage === '/user_collections'"
                    :key="'user_collections'"
                    :id="catalogueID"
                    type="user_collections_release"
                    api-route="entries_parent"
                    :api-params="{
                      parent_model: 'release',
                      parent_id: this.resource.id,
                      so: 'style_asc',
                      rus: true,
                    }"
                    search-placeholder="search"
                    default_item_component="ItemPictureTextInfo"
                    :dialog_buttons="[]"
                    :dialogs="{}"
                    :dialog_properties="[]"
                    :dialog_sources="{}"
                    :hide_dialogs="{}"
                    hide-search
                    picture-listing-label="author_user"
                    :custom-zero-results-message="$t('not in user collections')"
                >
                </list-browser>
                <!-- // usercollections of the release -->

                <!-- posts -->
                <list-browser
                    class="mt-1"
                    v-if="subPage === '/posts'"
                    :key="'posts'"
                    :id="catalogueID"
                    type="posts"
                    api-route="posts"
                    :api-params="{
                      parent_model: 'release',
                      parent_id: this.resource.id,
                    }"
                    search-placeholder="search posts"
                    default_item_component="ItemPictureTextInfo"
                    :dialog_buttons="[]"
                    :dialogs="{}"
                    :dialog_properties="[]"
                    :dialog_sources="{}"
                    :hide_dialogs="{}"
                    hide-search
                    hide-control-buttons
                    :master-link="{
                        'label': $t('write a post'),
                        'icon': 'mdi-pencil-plus-outline',
                        'to': '/release/'+resource.public_id+'/posts/new'
                    }"
                    :custom-zero-results-message="$t('no posts')"
                >
                </list-browser>
                <!-- // posts -->

                <!-- photos -->
                <list-browser
                    class="mt-1"
                    v-if="subPage === '/photos'"
                    :key="'photos'"
                    :id="catalogueID"
                    type="photos"
                    api-route="photos_"
                    :api-params="{
                      parent_model: 'release',
                      parent_id: this.resource.id,
                    }"
                    default_item_component="ItemPicture"
                    :dialog_buttons="[]"
                    :dialogs="{}"
                    :dialog_properties="[]"
                    :dialog_sources="{}"
                    :hide_dialogs="{}"
                    hide-search
                    hide-control-buttons
                    :reaction_buttons="false"
                    :master-link="{
                        'label': $t('add picture'),
                        'icon': 'mdi-plus-box-outline',
                        'to': '/release/'+resource.public_id+'/photos/new'
                    }"
                    :custom-zero-results-message="$t('no pictures')"
                >
                </list-browser>
                <!-- // photos -->

                <!-- videos -->
                <list-browser
                    class="mt-1"
                    v-if="subPage === '/videos'"
                    :key="'videos'"
                    :id="catalogueID"
                    type="videos"
                    api-route="videos_"
                    :api-params="{
                      parent_model: 'release',
                      parent_id: this.resource.id,
                    }"
                    search-placeholder="search videos"
                    default_item_component="ItemPicture"
                    :dialog_buttons="[]"
                    :dialogs="{}"
                    :dialog_properties="[]"
                    :dialog_sources="{}"
                    :hide_dialogs="{}"
                    hide-search
                    hide-control-buttons
                    :reaction_buttons="false"
                    :master-link="{
                        'label': $t('add video'),
                        'icon': 'mdi-plus-box-outline',
                        'to': '/release/'+resource.public_id+'/videos/new'
                    }"
                    :custom-zero-results-message="$t('no videos')"
                >
                </list-browser>
                <!-- // videos -->

                <!-- buying_options -->
                <BuyingOptions
                    v-if="subPage === '/buying_options' && resource"
                    take="30"
                    horizontal="true"
                    :parent_id="resource.public_id"
                    :parent_model="resource.model.toLowerCase()"
                    :format_id="resource.format ? resource.format.id : null"
                    :keyword="associateKw"
                    :campaign_ids="{amazon: 'release_b'}"
                    :country_id="resource.country ? resource.country.id : null"
                >
                </BuyingOptions>
                <!-- // buying_options -->

                <!-- history -->
                <list-browser
                    class="mt-1"
                    v-if="subPage === '/history'"
                    :key="'history'"
                    :id="catalogueID"
                    type="history"
                    api-route="history"
                    :api-params="{
                      re: this.resource.id,
                      rus: true,
                      rmo: true,
                    }"
                    default_item_component="ChangesPictureTextInfo"
                    :dialog_buttons="[]"
                    :dialogs="{}"
                    :dialog_properties="[]"
                    :dialog_sources="{}"
                    :hide_dialogs="{}"
                    hide-search
                    hide-control-buttons
                    :reaction_buttons="false"
                    heading="page history"
                    :custom-zero-results-message="$t('no history')"
                >
                </list-browser>
                <!-- // history -->

                <contact-form
                    v-if="subPage === '/contact'"
                    model="release"
                    :public-id="resource.public_id"
                    :auth-user="$store.state.auth_user"
                ></contact-form>

            </keep-alive>

        </v-col>
        <!-- large screen shopping links -->
        <v-col xl="2" lg="2" md="2" cols="12" v-if="$vuetify.breakpoint.name != 'xs' && $vuetify.breakpoint.name != 'sm'">
            <ShoppingLinks
                :resource-links="resource.shopping_links"
                :fall-back-picture="resource.picture"
                :general-links-fixed-height="120"
                :keyword="resource.titles.length > 0 ? resource.titles[0].name+' '+resource.titles[0].year : resource.name"
                :format-id="resource.format ? resource.format.id : null"
                :country-id="resource.country ? resource.country.id : null"
                :parent-model="resource.model"
                :parent-id="resource.id"
                :user-login="Boolean($store.state.auth_user)"
                :mode="1"
                class="mb-16"
            />

            <!--
            <BuyingOptions
                class="mt-16"
                v-if="resource && subPage != '/buying_options'"
                take="6"
                :parent_id="resource.public_id"
                :parent_model="resource.model.toLowerCase()"
                :format_id="resource.format ? resource.format.id : null"
                :keyword="associateKw"
                :campaign_ids="{amazon: 'release_b'}"
                :country_id="resource.country ? resource.country.id : null"
            >
            </BuyingOptions>
            -->
        </v-col>

        <!-- the bottom menu -->
        <v-bottom-navigation
            app
            fixed
            align="center"
        >
            <user-action-buttons
                :buttons="userActionButtons"
                @add_owned_count="resource.owned_count_auth++;resource.list_entries_count_auth++;snackbar=true;snackbar_message=$t('added to list', [$event])"
                @sub_owned_count="resource.owned_count_auth--;resource.list_entries_count_auth--;snackbar=true;snackbar_message=$t('removed from list', [$event])"
                @add_wanted_count="resource.wanted_count_auth++;resource.list_entries_count_auth++;snackbar=true;snackbar_message=$t('added to list', [$event])"
                @sub_wanted_count="resource.wanted_count_auth--;resource.list_entries_count_auth--;snackbar=true;snackbar_message=$t('removed from list', [$event])"
                @increaseLikesValue="resource.likes_count_auth++;resource.likes_count++;snackbar=true;snackbar_message=$t('you like this')"
                @decreaseLikesValue="resource.likes_count_auth--;resource.likes_count--;snackbar=true;snackbar_message=$t('like removed')"
                @openList="$root.$emit('user-collections', resource)"
            >
            </user-action-buttons>
        </v-bottom-navigation>

        <!-- snackbar for brief messages -->
        <v-snackbar
            v-model="snackbar"
            :timeout="snackbar_timeout"
            color="green"
            style="bottom:70px;"
        >
            <div class="text-center">
                {{ snackbar_message }}
            </div>
        </v-snackbar>

        <!-- photo dialog -->
        <v-dialog
            v-model="dialog"
            max-width="1200px"
        >
            <PhotosDialog
                :item="resource.picture"
                @dialog="dialog = $event"
            >
            </PhotosDialog>
        </v-dialog>
        <!-- video dialog -->
        <v-dialog
            v-model="dialog_video"
        >
            <VideoPlayer
                :item="resource.trailer"
                @dialog="dialog_video = $event"
            ></VideoPlayer>
        </v-dialog>
        <!-- dialog_delete dialog -->
        <v-dialog
            v-model="dialog_delete"
            max-width="500"
        >
            <v-card color="red" class="darken-3">

                <v-card-title>{{ $t('delete') }} {{ $t('release') }}</v-card-title>

                <v-card-text>
                    {{ $t('delete release hint') }}
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="red"
                        @click="deleteRelease"
                    >
                        {{ $t('confirm delete') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialog_value"
            max-width="600"
        >
            <v-card color="black" class="darken-3">
                <v-icon
                    class="float-right mr-2 mt-2"
                    @click="dialog_value = false"
                >
                    mdi-close
                </v-icon>
                <v-card-title>
                    <v-icon class="mr-3" color="green" style="font-size: 1.5em">mdi-information-slab-circle-outline</v-icon> {{ $t('value') }}
                </v-card-title>
                <v-card-text>
                    <div><v-icon>mdi-cash-check</v-icon> {{ $t('average value info') }}</div>
                    <div class="mt-2"><v-icon>mdi-account-voice</v-icon> {{ $t('value voice info') }}</div>
                    <div class="mt-2"><v-icon color="red">mdi-arrow-up-bold</v-icon> {{ $t('value max info') }}</div>
                    <div class="mt-2"><v-icon color="green">mdi-arrow-down-bold</v-icon> {{ $t('value min info') }}</div>
                    <div class="mt-6">{{ $t('value info') }}</div>
                    <div class="mt-6">{{ $t('value info 1') }}</div>
                    <div class="mt-6"><v-icon>mdi-playlist-plus</v-icon>{{ $t('value info 2') }}</div>
                    <div class="mt-3">
                        <span class="vs-link" @click="badPriceClick" >
                            {{ $t('report bad price') }}
                        </span>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-row>
    <v-skeleton-loader
        v-else
        style="max-width: 1500px"
        type="article"
    />

</template>

<script>
import useApiResource from '@/composables/useApiResource'
import useDialogsResource from "../composables/useDialogsResource";
import useImgMethods from "../composables/useImgMethods";
import useStringMethods from "../composables/useStringMethods";
const ShoppingLinks = () =>  import("@/components/ShoppingLinks.vue");
const BuyingOptions = () =>  import("@/components/misc/BuyingOptions.vue");
const SubPageButtons = () =>  import("@/components/SubPageButtons.vue");
const userActionButtons = () => import("@/components/UserActionButtons.vue");
const ListBrowser = () =>  import("@/components/ListBrowser.vue");
//const ListingPicture = () =>  import("@/components/listings/ListingPicture.vue");
const DetailsTable = () =>  import("@/components/DetailsTable.vue");
const PhotosDialog = () =>  import("@/components/dialogs/PhotosDialog.vue");
const VideoPlayer = () =>  import("@/components/videoPlayer.vue");
const ContactForm = () =>  import("@/components/ContactForm.vue");
const ShareButton = () =>  import("@/components/ShareButton.vue");

export default {
    name: "Release",
    components: {
        ShoppingLinks,
        VideoPlayer,
        //ListingPicture,
        ListBrowser,
        BuyingOptions,
        SubPageButtons,
        userActionButtons,
        DetailsTable,
        PhotosDialog,
        ContactForm,
        ShareButton,
    },
    props: {
        baseUrl: String,
        resourcePath: String,
        resourceParams: Object,
        publicId: String,
        subPage: String,
        pre_meta_name: String,
        pre_meta_description: String,
    },
    setup(props) {
        const { resource, resourceLoading, getResource } = useApiResource(props)
        const { releaseDialogs, movieDialogs,reviewDialogs } = useDialogsResource()
        const { imgSrc, clickPicture } = useImgMethods()
        const { cutStringByWords, wordCount } = useStringMethods()

        return {
            resource,
            resourceLoading,
            getResource,
            releaseDialogs,
            movieDialogs,
            reviewDialogs,
            imgSrc,
            clickPicture,
            cutStringByWords,
            wordCount
        }
    },
    data: function () {
        return {
            catalogueID: 'catalogue',
            dialog: false,
            dialog_video: false,
            dialog_delete: false,
            dialog_value: false,
            dialogs: false,
            snackbar: false, //snackbar notification open or clase
            snackbar_message: null, //message
            snackbar_timeout: 3000, //time
            showAllBackCover: false,
            showAllExtras: false,
            showAllPackaging: false,
            showAllCensorship: false,
            showAllMastering: false,
            goToParams: {
                duration: 100,
                offset: 150,
                easing: 'easeInOutCubic',
            }
        }
    },
    metaInfo() {
        return {
            title: this.metaName,
            meta: [
                {property: 'og:title', content: this.metaName},
                {name: 'description', content: this.metaDescription},
                {property: 'og:site_name', content: 'VideoSpace'},
                {property: 'og:type', content: 'website'},
                {name: 'robots', content: this.$t('robots meta')}
            ],
            link: [
                { rel: 'canonical', href: 'https://videospace.fi/release/'+this.resource.public_id+(this.subPage != '/' ? this.subPage : '') }
            ]
        }
    },
    methods: {
        badPriceClick(){

            this.dialog_value=false
            this.$router.push({ path: '/release/'+this.resource.public_id+'/contact'})

        },
        labelGroupName(id){

            if(this.resource.label_groups && this.resource.label_groups.findIndex(x => x.id == id) > -1)
                return this.resource.label_groups[this.resource.label_groups.findIndex(x => x.id == id)].name

        },
        secondsToMinutes(seconds){
            return new Date(seconds * 1000).toISOString().substr(14, 5)
        },
        //display date
        momentFormat(date, format = 'DD/MM/YYYY'){

            return this.$day(date).format(format)

        },
        deleteRelease(){
            this.axios.delete('/releases/'+this.resource.id).then((response) => {
                this.dialog_delete = false
                if(response.data.status == 'waiting')
                    this.$root.$emit('snackbar', {'message': this.$t('delete request sent'), 'color': 'green'})
                else{
                    this.$root.$emit('snackbar', {'message': this.$t('deleted'), 'color': 'green'})
                    setTimeout(
                        function(){
                            window.location.href = '/releases'
                        }, 2000
                    )
                    /* use this when list can be reset. replace window

                    this.$store.commit('resetRelease', true)
                    setTimeout(
                        function(){
                            this.$router.push('/releases')
                        }.bind(this), 1000
                    )
                    */
                }

            })
        }
    },
    watch:{

        //owned_count_auth, wanted_count_auth, likes_count_auth, list_entries_count_auth
        //if emit changes to selected properties to change values also in parent list
        'resource.owned_count_auth'(newValue, oldValue){
            if(typeof oldValue == 'undefined') return //disregard the first pass when resource is loaded and values are not set

            this.$root.$emit('parentListValueUpdate', {
                parent_model: 'release',
                parent_model_id: this.resource.id,
                property_name: 'owned_count_auth',
                property_value: newValue,
            })
        },
        'resource.wanted_count_auth'(newValue, oldValue){
            if(typeof oldValue == 'undefined') return //disregard the first pass when resource is loaded and values are not set

            this.$root.$emit('parentListValueUpdate', {
                parent_model: 'release',
                parent_model_id: this.resource.id,
                property_name: 'wanted_count_auth',
                property_value: newValue,
            })
        },
        'resource.likes_count_auth'(newValue, oldValue){
            if(typeof oldValue == 'undefined') return //disregard the first pass when resource is loaded and values are not set

            this.$root.$emit('parentListValueUpdate', {
                parent_model: 'release',
                parent_model_id: this.resource.id,
                property_name: 'likes_count_auth',
                property_value: newValue,
            })
        },
        'resource.list_entries_count_auth'(newValue, oldValue){
            if(typeof oldValue == 'undefined') return //disregard the first pass when resource is loaded and values are not set

            this.$root.$emit('parentListValueUpdate', {
                parent_model: 'release',
                parent_model_id: this.resource.id,
                property_name: 'list_entries_count_auth',
                property_value: newValue,
            })
        },
        $route(to){
            if(to.name === 'Release')
                //if route is Release and if reset_release is set in any referring view
                if(this.$store.state.reset_release) {
                    this.$store.commit('resetRelease', false) //reset reset_release state into false
                    this.getResource() //refresh resource
                }
        }
    },
    computed: {

        valueAvg(){
            if(this.resource.price_avg && this.resource.price_avg > 0)
                return (this.resource.price_avg / 100).toFixed(2);

            return null
        },
        valueMax(){
            if(this.resource.price_max && this.resource.price_max > 0)
                return (this.resource.price_max / 100).toFixed(2);
            return null
        },
        valueMin(){
            if(this.resource.price_min && this.resource.price_min > 0)
                return (this.resource.price_min / 100).toFixed(2);
            return null
        },
        HDRString(){
            let str = ''
            if(this.resource.HDR) str = 'HDR '
            if(this.resource.HDR10) str = 'HDR10 '
            if(this.resource.HDR_dolby_vision) str += 'Dolby vision'
            if(this.resource.HDR10 && this.resource.HDR_dolby_vision) str = 'HDR10 & Dolby Vision'
            return str
        },
        thirdString(){
            let str = ''
            if(this.resource['3D'] == 1) str = this.$t('anaglyph 3d')
            if(this.resource['3D'] == 2) str = this.$t('bluray 3d')
            if(this.resource['3D'] == 3) str = this.$t('both 3d')
            return str
        },

        mastering(){
            let str = ''
            if(this.resource.scan_resolution == 1) str = '2K'
            if(this.resource.scan_resolution == 2) str = '4K'
            if(this.resource.scanSource) str += ' '+this.resource.scanSource.name
            return str
        },

        processing(){
            let str = null
            if(this.resource.DNR_processing == 1) str = 'DNR '+this.$t('mild')
            if(this.resource.DNR_processing == 2) str = 'DNR '+this.$t('heavy')
            if(str) str += ', '
            if(this.resource.AI_processing == 1) str += 'AI '+this.$t('mild')+' '
            if(this.resource.AI_processing == 2) str += 'AI '+this.$t('heavy')+' '
            return str
        },

        associateKw(){

            if(this.resource.titles[0]) return this.resource.titles[0].name

            return this.resource.name
        },
        userActionButtons(){

            return [
                {
                    id: 'have',
                    title: 'have it',
                    icon: 'mdi-flag-outline',
                    icon_selected: 'mdi-flag',
                    value_name: 'owned_count_auth',
                    value: this.resource.owned_count_auth,
                    action: 'toggle',
                    list_value: true,
                    api_post_action: 'my_owned_collection_toggle',
                    api_post_values: {model: this.resource.model, model_id: this.resource.id},
                    emits: 'owned_count'
                },
                {
                    id: 'want',
                    title: 'wanted',
                    icon: 'mdi-flag-plus-outline',
                    icon_selected: 'mdi-flag-plus',
                    value_name: 'wanted_count_auth',
                    value: this.resource.wanted_count_auth,
                    action: 'toggle',
                    list_value: true,
                    api_post_action: 'my_wanted_collection_toggle',
                    api_post_values: {model: this.resource.model, model_id: this.resource.id},
                    emits: 'wanted_count'
                },
                {
                    id: 'like',
                    title: 'like',
                    icon: 'mdi-heart-outline',
                    icon_selected: 'mdi-heart',
                    value_name: 'likes_count_auth',
                    secondary_value_name: 'likes_count',
                    value: this.resource.likes_count_auth,
                    action: 'toggle',
                    api_post_action: 'reactions',
                    api_post_values: {model: this.resource.model, model_id: this.resource.id}
                },
                {
                    id: 'list',
                    title: 'add to list',
                    icon: 'mdi-playlist-plus',
                    icon_selected: 'mdi-playlist-check',
                    value_name: 'list_entries_count_auth',
                    value: this.resource.list_entries_count_auth,
                    action: 'open-list',
                    badge: true,
                },
            ]

        },
        metaName(){

            let meta = this.pre_meta_name
            if(this.resource.id){
                meta = this.resource.name
                meta += this.resource.format ? ' '+this.resource.format.full_name : ''
                meta += this.resource.package_type ? ' ('+this.resource.package_type.name+')' : ''
                meta += this.resource.labels.length > 0 ? ' '+this.resource.labels[0].name : ''
                meta += this.resource.label_id ? ' '+this.resource.label_id : ''
            }
            return meta

        },
        metaDescription(){
            let meta = this.pre_meta_description
            if(this.resource.id){
                meta = this.resource.format ? this.resource.format.full_name+' release' : ''
                meta += this.resource.name ? ' '+this.resource.name : ''
                meta += this.resource.labels.length > 0 ? ' from '+this.resource.labels[0].name : ''
                meta += this.resource.label_groups.length > 0 ? '/'+this.resource.label_groups[0].name : ''
                meta += this.resource.label_id ? ' ('+this.resource.label_id+')' : ''
                meta += this.resource.package_type ? ' in '+this.resource.package_type.name : ''
                meta += this.resource.released_at ? ' Release date '+this.momentFormat(this.resource.released_at, 'MMMM D, YYYY') : ''
            }
            return meta
        },
        //a short version of details, will be displayed in the beginning
        basicInfo(){
            if(this.resource)
                return [
                    {
                        visible: this.resource.titles_count ? true : false,
                        type: 'array',
                        name: this.$t('movie'),
                        name_plural: this.$t('movies'),
                        content: this.resource.titles.slice(0,5),
                        content_count: this.resource.titles_count,
                        link_base: '/movie/',
                        see_all_link: this.baseUrl+'/'+this.publicId+'/movies',
                        count: this.resource.titles_count,
                    },
                    {
                        visible: this.resource.labels.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('label'),
                        name_plural: this.$t('labels'),
                        content: this.resource.labels.slice(0,5),
                        content_count: this.resource.labels.length,
                        link_base: '/label/'
                    },
                    {
                        visible: this.resource.label_groups.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('label groups'),
                        name_plural: this.$t('label group'),
                        content: this.resource.label_groups.slice(0,5),
                        content_count: this.resource.label_groups.length,
                        link_base: '/label/',
                        label_group: true
                    },
                    {
                        visible: this.resource.label_id ? true : false,
                        type: 'string',
                        name: this.$t('label id'),
                        content: this.resource.label_id,
                    },
                    {
                        visible: this.resource.country ? true : false,
                        type: 'array',
                        name: this.$t('release country'),
                        content: [this.resource.country],
                        link_base: '/releases?co='
                    },
                    {
                        visible: this.resource.released_at && this.$day(this.resource.released_at).unix() > this.$day().unix() ? true : false,
                        type: 'string',
                        name: this.$t('coming soon'),
                        content: this.momentFormat(this.resource.released_at)
                    },
                ]

            return []
        },
        completeInfo(){
            if(this.resource)
                return [
                    {
                        visible: this.resource.titles_count ? true : false,
                        type: 'array',
                        name: this.$t('movie'),
                        name_plural: this.$t('movies'),
                        content: this.resource.titles.slice(0,5),
                        content_count: this.resource.titles_count,
                        link_base: '/movie/',
                        see_all_link: this.baseUrl+'/'+this.publicId+'/movies',
                        count: this.resource.titles_count,
                    },
                    {
                        visible: this.resource.format ? true : false,
                        type: 'array',
                        name: this.$t('format'),
                        content: [this.resource.format],
                        link_base: '/releases?fo='
                    },
                    {
                        visible: this.resource.region ? true : false,
                        type: 'string',
                        name: this.$t('region code'),
                        content: this.resource.region,
                    },
                    {
                        visible: this.resource.package_type ? true : false,
                        type: 'array',
                        name: this.$t('package type'),
                        content: [this.resource.package_type],
                    },
                    {
                        visible: this.resource.slipcover ? true : false,
                        type: 'string',
                        name: this.$t('slipcover'),
                        content: this.$t('yes')+(this.resource.slipcover_limited_to ? ' ('+this.$t('slipcover limited to')+': '+this.resource.slipcover_limited_to+')' :''),
                    },
                    {
                        visible: this.resource.labels.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('label'),
                        name_plural: this.$t('labels'),
                        content: this.resource.labels.slice(0,5),
                        content_count: this.resource.labels.length,
                        link_base: '/label/'
                    },
                    {
                        visible: this.resource.label_groups.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('label groups'),
                        name_plural: this.$t('label group'),
                        content: this.resource.label_groups.slice(0,5),
                        content_count: this.resource.label_groups.length,
                        link_base: '/label/',
                        label_group: true
                    },
                    {
                        visible: this.resource.label_id ? true : false,
                        type: 'string',
                        name: this.$t('label id'),
                        content: this.resource.label_id,
                    },
                    {
                        visible: this.resource.country ? true : false,
                        type: 'array',
                        name: this.$t('release country'),
                        content: [this.resource.country],
                        link_base: '/releases?co='
                    },
                    {
                        visible: this.resource.aspect_ration ? true : false,
                        type: 'array',
                        name: this.$t('aspect ratio'),
                        content: [this.resource.aspect_ration]
                    },
                    {
                        visible: this.resource.aspect_ration && this.resource.anamorphic ? true : false,
                        type: 'string',
                        name: this.$t('anamorphic'),
                        content: this.$t('yes'),
                    },
                    {
                        visible: this.resource['3D'] && this.resource['3D'] ? true : false,
                        type: 'string',
                        name: this.$t('3d label'),
                        content: this.thirdString,
                    },
                    {
                        visible: this.resource.RRP && this.resource.rrp_currency ? true : false,
                        type: 'string',
                        name: this.$t('rrp'),
                        content: this.resource.RRP+' '+this.resource.rrp_currency?.label,
                    },

                    {
                        visible: this.resource.OOP ? true : false,
                        type: 'string',
                        name: this.$t('rrp'),
                        content: this.$t('yes'),
                    },
                    {
                        visible: this.resource.HDR ? true : false,
                        type: 'string',
                        name: 'HDR',
                        content: this.HDRString,
                    },
                    {
                        visible: this.mastering ? true : false,
                        type: 'string',
                        name: this.$t('mastering'),
                        content: this.mastering,
                    },
                    {
                        visible: this.processing ? true : false,
                        type: 'string',
                        name: this.$t('processing'),
                        content: this.processing,
                    },
                    {
                        visible: this.resource.upscaled ? true : false,
                        type: 'string',
                        name: 'upscale',
                        content: this.$t('yes'),
                    },

                    {
                        visible: this.resource.cut_uncut ? true : false,
                        type: 'string',
                        name: this.$t('censorship'),
                        content: this.resource.cut_uncut == 2 ? this.$t('release is uncut') : this.$t('release is cut')+(this.resource.cut_seconds ? ' '+this.secondsToMinutes(this.resource.cut_seconds)+' '+this.$t('min sec') : ''),
                    },
                    {
                        visible: this.resource.spoken_languages.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('spoken languages'),
                        content: this.resource.spoken_languages,
                        content_count: this.resource.spoken_languages.length,
                        link_base: '/releases?ls='
                    },
                    {
                        visible: this.resource.subtitle_languages.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('subtitle languages'),
                        content: this.resource.subtitle_languages,
                        content_count: this.resource.subtitle_languages.length,
                        link_base: '/releases?lt='
                    },
                    {
                        visible: this.resource.media_pcs ? true : false,
                        type: 'string',
                        name: this.resource.format && this.resource.format.id == 2 ? this.$t('tapes') : this.$t('discs'),
                        content: this.resource.media_pcs,
                    },
                    {
                        visible: this.resource.released_at ? true : false,
                        type: 'string',
                        name: this.$t('street date'),
                        content: this.momentFormat(this.resource.released_at),
                    },
                    {
                        visible: !this.resource.released_at && this.resource.year ? true : false,
                        type: 'string',
                        name: this.$t('release year'),
                        content: this.resource.year,
                    },
                    {
                        visible: this.resource.limited_to ? true : false,
                        type: 'string',
                        name: this.$t('limited to'),
                        content: this.resource.limited_to+' '+this.$t('pcs'),
                    },
                    {
                        visible: this.resource.ean ? true : false,
                        type: 'string',
                        name: this.$t('ean code'),
                        content: this.resource.ean,
                    },
                    {
                        visible: this.resource.updated_at ? true : false,
                        type: 'string',
                        name: this.$t('page updated at'),
                        content: this.momentFormat(this.resource.updated_at),
                    },
                    {
                        visible: this.resource.created_at ? true : false,
                        type: 'string',
                        name: this.$t('page created at'),
                        content: this.momentFormat(this.resource.created_at),
                    },
                ]

            return []
        },
        subPageButtons(){
            if(this.resource)
                return [
                {
                    id: 'main',
                    route: '',
                    label: 'details',
                },
                {
                    id: 'movies',
                    route: '/movies',
                    label: 'movies',
                    show_min: 1,
                    value: this.resource.titles_count
                },
                {
                    id: 'other_releases',
                    route: '/other_releases',
                    label: 'other releases',
                    value: this.resource.other_releases_count
                },
                {
                    id: 'pictures',
                    route: '/photos',
                    label: 'pictures',
                    value: this.resource.pictures_count
                },
                {
                    id: 'collections',
                    route: '/user_collections',
                    label: 'user collections',
                    value: this.resource.list_entries_count
                },
                {
                    id: 'reviews',
                    route: '/reviews',
                    label: 'reviews',
                    value: this.resource.user_reviews_rating_count
                },
                {
                    id: 'buying_options',
                    route: '/buying_options',
                    label: 'buying options',
                },

                {
                    id: 'videos',
                    route: '/videos',
                    label: 'videos',
                    value: this.resource.videos_count
                },
                {
                    id: 'discussions',
                    route: '/posts',
                    label: 'discussions',
                    value: this.resource.posts_count
                },
                {
                    id: 'tools',
                    label: 'tools',
                    fixed_color: '#a1030e',
                    menu: [
                        {
                            id: 'edit',
                            route: '/edit',
                            label: 'edit',
                        },
                        {
                            id: 'duplicate',
                            route: '/duplicate',
                            label: 'duplicate',
                        },
                        {
                            id: 'history',
                            route: '/history',
                            label: 'page history',
                        },
                        {
                            id: 'contact',
                            route: '/contact',
                            label: 'contact us',
                        },
                        {
                            id: 'delete',
                            dialog: 'delete',
                            label: 'delete',
                            fixed_color: 'red',
                        },
                    ]
                },
            ]

            return []
        }

    },
    created(){

        this.$root.$on('videospace', function(payload){
            if(this.resource.id == payload.model_id && this.resource.model.toLowerCase() == payload.model.toLowerCase()) {

                //update existing item with received data
                for (const [key, value] of Object.entries(payload.data)) {

                    if (value == "sub") this.resource[key] = this.resource[key] - 1 > -1 ? this.resource[key] - 1 : 0 //subtract from original value. do not go under 0
                    if (value == "add") this.resource[key] = this.resource[key] + 1 //add to original value

                    if (value != "add" && value != "sub") this.resource[key] = value //update value
                }
            }
        }.bind(this))
    }
}
</script>

<style scoped>
</style>
